import type { FaireProductEntity } from "../../entity_types/product";

export const p_k297j3bjqv: FaireProductEntity = {
  token: "p_k297j3bjqv",
  type: "product",
  name: "Japanese Quince Toile Pagoda Candle",
  brandToken: "b_17b2255b",
  brandName: "Seda France Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/1e87ac6e883303fe6fc278af6b293fa69ae9a7e91f54f805f3567746eeac7de0.jpeg",
  galleryImageUrls: [],
  priceDollars: 18.75,
  description:
    "Japanese quince classic toile mini pagoda box candle.\nA piquant fragrance with aspects of rhubarb, passion fruit and white fleshed peach over a heart of white jasmine petals. This powerful and diffusive fragrance is one of our best sellers. Always the perfect gift.\nBurn time: 100+ hours.\n10.2 oz.",
  tags: [],
  msrpDollars: 37.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:57.931Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
